import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { delay } from 'q';

@Component({
  selector: 'app-subscribe-result-success',
  templateUrl: './subscribe-result-success.component.html',
  styleUrls: ['./subscribe-result-success.component.css'],
  animations: [
    trigger('resultState', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
      transition('hide => show', animate('0.3s ease-out')),
      transition('show => hide', animate('0.3s ease-in'))
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class SubscribeResultSuccessComponent implements OnInit {
  
  @Input() state = 'hide'

  constructor() { }

  ngOnInit() {
  }

  hide() {
    if (this.state == 'show') {
      setTimeout(() => {
        this.state = 'hide'
      }, 3000);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/subscribe-result-success/subscribe-result-success.component.ts